function HeirCard({ heredero, onEliminar }) {
  const nivelLabel = {
    '1': 'Nivel 1 — Suscripciones',
    '2': 'Nivel 2 — Cuentas digitales',
    '3': 'Nivel 3 — Documentos privados',
  }

  const esConfirmador = heredero.rol === 'confirmer'

  return (
    <div style={{
      ...estilos.tarjeta,
      borderLeft: esConfirmador
        ? '4px solid #f0ad4e'
        : '4px solid #1a1a2e'
    }}>
      <div style={estilos.fila}>
        <div>
          <span style={estilos.nombre}>{heredero.nombre_completo}</span>
          <span style={{
            ...estilos.badge,
            backgroundColor: esConfirmador ? '#fff3cd' : '#e8f4fd',
            color: esConfirmador ? '#856404' : '#0c5460',
          }}>
            {esConfirmador ? 'Mi guardián' : nivelLabel[heredero.nivel]}
          </span>
        </div>
        <button
          onClick={() => onEliminar(heredero.id)}
          style={estilos.btnEliminar}
        >
          Eliminar
        </button>
      </div>

      <div style={estilos.email}>{heredero.email}</div>

      {heredero.relacion && (
        <div style={estilos.detalle}>Relación: {heredero.relacion}</div>
      )}

      {heredero.telefono && (
        <div style={estilos.detalle}>Tel: {heredero.telefono}</div>
      )}

      {heredero.notas && (
        <div style={estilos.notas}>{heredero.notas}</div>
      )}

      {esConfirmador && (
        <div style={estilos.infoConfirmador}>
          Tu guardián recibirá el aviso de alerta y activará el acceso a tu información cuando sea necesario.
        </div>
      )}
    </div>
  )
}

const estilos = {
  tarjeta: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '16px 20px',
    marginBottom: '12px',
    border: '1px solid #e0e0e0',
  },
  fila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '8px',
  },
  nombre: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#1a1a2e',
    display: 'block',
    marginBottom: '4px',
  },
  badge: {
    fontSize: '11px',
    padding: '2px 10px',
    borderRadius: '20px',
    fontWeight: '500',
    display: 'inline-block',
  },
  email: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '4px',
  },
  detalle: {
    fontSize: '12px',
    color: '#888',
    marginBottom: '2px',
  },
  notas: {
    fontSize: '12px',
    color: '#888',
    marginTop: '6px',
    fontStyle: 'italic',
  },
  infoConfirmador: {
    fontSize: '12px',
    color: '#856404',
    backgroundColor: '#fff3cd',
    padding: '6px 10px',
    borderRadius: '4px',
    marginTop: '8px',
  },
  btnEliminar: {
    fontSize: '12px',
    color: '#dc3545',
    backgroundColor: 'transparent',
    border: '1px solid #dc3545',
    padding: '4px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
}

export default HeirCard